import axios from '../utils/functions/api';
import api from '../utils/functions/api';
import { setStorage } from '../utils/functions/localstorage';

const baseURL = process.env.REACT_APP_API_URL;

async function checkMerchantApi(merchantPath) {
    try {
        const resp = await api.get(`${baseURL}/auth/check-merchant/${merchantPath}`)

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function registerApi(payload) {
    try {
        const resp = await api.post(`${baseURL}/auth/register-user`, payload);
        const token = resp.data?.access_token;
        await setStorage('token', token);

        return { success: true, result: true, };
    } catch (error) {
        return { success: false, result: error.response.data.error, };
    }
}

async function getApproveConsentApi(token) {
    try {
        const resp = await api.get(`${baseURL}/manage-users/consent`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function postApproveConsentApi(payload, token) {
    try {
        const resp = await api.post(`${baseURL}/manage-users/consent`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

const AuthenticateApi = {
    checkMerchantApi,
    registerApi,
    getApproveConsentApi,
    postApproveConsentApi
};
export default AuthenticateApi;